export default __webpack_public_path__ + "images/MD.2bebc99.png";